/**
 * Testi italiani della pagina «InstitorAI DevHub» (app desktop per Windows compresa nel
 * piano Premium).
 */

/** Testi di DevHub. */
export const devhub = {
  nav: 'DevHub',
  title: 'InstitorAI DevHub',
  subtitle: 'L’app per Windows che tiene insieme i tuoi progetti, i servizi in esecuzione e l’agente che ci lavora.',
  loadFailed: 'Non è stato possibile leggere la pagina. Riprova.',
  whatTitle: 'Che cosa fa',
  features: {
    projects: 'Avvii e fermi i servizi, lanci test e deploy di ogni progetto.',
    claude: 'Claude Code in conversazione o nel terminale, una sessione per progetto.',
    questions: 'Domande aperte e TODO: l’agente chiede e intanto va avanti.',
    credentials: 'Credenziali cifrate sul PC, usate dall’agente senza leggerle.',
    remote: 'Server, tunnel, cluster e un browser per progetto.',
    telegram: 'Le domande dell’agente anche su Telegram.',
  },
  reqTitle: 'Che cosa serve',
  req: {
    windows: 'Windows 10 o 11.',
    claude: 'Il tuo account Claude Code: DevHub lo avvia, non lo include.',
    license: 'La licenza di DevHub: compresa nel piano Premium, oppure da sola con un abbonamento mensile.',
  },
  offer: {
    badge: 'Nel Premium o da solo',
    title: 'Ottieni DevHub',
    text: 'DevHub è compreso nel piano Premium. Se non ti serve Premium, puoi abbonarti solo a DevHub. Oggi hai il piano {{plan}}.',
    cta: 'Passa a Premium',
    licenseCta: 'Abbonati solo a DevHub',
    licensePrice: 'Solo DevHub: {{price}} al mese, disdici quando vuoi.',
  },
  active: 'DevHub è compreso nel tuo piano Premium.',
  activeLicense: 'Hai la licenza di DevHub. Si rinnova il {{date}}.',
  activeLicenseEnds: 'Hai la licenza di DevHub fino al {{date}}.',
  billing: {
    title: 'InstitorAI DevHub',
    text: 'La licenza dell’app per Windows, anche senza Premium. Il piano Premium la comprende già.',
    included: 'Compresa nel tuo piano',
    active: 'Attiva',
    renews: 'Si rinnova il {{date}}.',
    ends: 'Termina il {{date}}.',
    buy: 'Abbonati a DevHub',
    exists: 'Hai già la licenza di DevHub. La gestisci da «Gestisci abbonamento».',
    open: 'Vai a DevHub',
  },
  result: {
    done: 'Licenza di DevHub attiva',
    doneHint: 'Scarica l’app e la chiave di licenza dalla pagina DevHub.',
  },
  download: {
    title: 'Scarica l’app',
    latest: 'Versione {{version}} del {{date}}',
    sha: 'SHA-256',
    button: 'Scarica per Windows',
    buttonLabel: 'Scarica InstitorAI DevHub {{version}} per Windows',
    failed: 'Download non riuscito. Riprova.',
    notReady: 'Il download arriva a breve: stiamo preparando la prima versione.',
    none: 'Ancora nessuna versione pubblicata.',
  },
  license: {
    title: 'Chiave di licenza',
    help: 'Copia la chiave e incollala in DevHub, nella finestra «Licenza».',
    label: 'Chiave di licenza',
    expires: 'Valida fino al {{date}}. Si rinnova con l’abbonamento.',
    issue: 'Genera la chiave',
    issueFailed: 'Non è stato possibile generare la chiave. Riprova.',
    notReady: 'La chiave arriva insieme alla prima versione dell’app.',
    missing: 'Non hai ancora una chiave di licenza.',
  },
  steps: {
    title: 'Come si attiva',
    download: 'Scarica e installa DevHub.',
    license: 'Apri DevHub, scegli «Licenza» e incolla la chiave.',
    claude: 'Accedi a Claude Code con il tuo account.',
  },
  versions: {
    title: 'Versioni',
    version: 'Versione',
    date: 'Data',
    notes: 'Note',
    sha: 'SHA-256',
    empty: 'Ancora nessuna versione.',
  },
};

/** Forma dei testi di DevHub. */
export type Devhub = typeof devhub;
